import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ButtonIconPosition, ButtonIntent, ButtonType } from '../shared/button-types';

@Component({
  selector: 'xemex-filled-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  styleUrl: './filled-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.intent-primary]': 'intent() === "primary"',
    '[class.intent-destructive]': 'intent() === "destructive"',
    '[class.full-width]': 'fullWidth()',
  },
  template: `
    <button mat-flat-button [disabled]="disabled() || loading()" [type]="type()">
      <mat-icon [style.display]="icon() && iconPosition() === 'start' ? null : 'none'">{{ icon() }}</mat-icon>
      <ng-content />
      <mat-icon iconPositionEnd [style.display]="icon() && iconPosition() === 'end' ? null : 'none'">{{ icon() }}</mat-icon>
    </button>
  `,
})
export class FilledButtonComponent {
  intent = input<ButtonIntent>('primary');
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  type = input<ButtonType>('button');
  icon = input<string>();
  iconPosition = input<ButtonIconPosition>('start');
  fullWidth = input<boolean>(false);
}
